<template>
  <div class="notice">
    <van-nav-bar
      title="用户消息"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-empty v-if="noticeList.length==0" description="暂无数据" />
    <div v-for="(item,index) in noticeList" :key="index" class="bitem">
      <div class="text">
        <h4>{{ item.title }}</h4>
        <span v-html="item.news"></span>
        <p @click="checkDetail(item)">查看详情</p>
      </div>
      <div class="time">{{item.createTime}}</div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  export default {
    components: {
    },
    data () {
      return {
        noticeList:[],
        pagesize: 0,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 1000000,
          noticeTitle: undefined,
          createBy: undefined,
          status: undefined
        },
        form:{
          msgid:null,
          zt:null,
        }
      }
    },
    created() {
      let that = this
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      checkDetail(row) {
        this.$dialog.alert({
          title: row.title,
          message: row.news,
          messageAlign: 'left'
        }).then(() => {
          this.$toast('已读')
          this.form.msgid = row.msgid;
          this.form.zt = '已读'
          this.$ajax.post('/system/user/usermsgzt',this.form).then(function (res) {

          })
        })
      }

    }

  }
</script>

<style lang="scss" scoped>
  .notice{
    margin-top: 2.875rem;
    padding: 1.25rem;
    .bitem{
      color: #757DA3;
      text-align: center;
      margin-bottom: 1.25rem;
      .text{
        padding: 1.25rem 1.25rem 0;
        background-color: #F8F8F8;
        border-radius: .3125rem;
        h4{
          color: #212F6E;
          margin: 0;
          line-height: 1.375rem;
          margin-bottom: .5rem;
        }
        span{
          font-size: .875rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        p{
          font-size: .75rem;
          margin: 0;
          padding: .5rem 0;
          border-top: 1px solid #EBEBEB;
          margin-top: .5rem;
        }
      }
      .time{
        font-size: .75rem;
        margin-top: .5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Message/index.vue